<!----INCIDENT FORM -->
<template>
    <div>
        <!--TITLE---------------------------------------------------->
            <div class="col-xs-12">
                <el-form-item label="Report Title:" prop="Title">
                    <el-input 
                        v-model="myController.Incident.Title" 
                        :maxlength="30" 
                        placeholder="Enter Report Title">
                    </el-input>
                </el-form-item>
            </div>

        <!--PREPARED BY---------------------------------------------->
            <div class="col-xs-12 col-sm-4 col-md-6 col-lg-6 ">
                <el-form-item label="Report Prepared By:" prop="AddedBy">
                    <el-select 
                        placeholder=" Select Staff Member" 
                        style="width: 100%;" 
                        v-model="myController.Incident.AddedBy">
                        <el-option 
                            v-for="item in myController.staffmembers" 
                            :key="item.Id" 
                            :label="item.Name" 
                            :value="item.Id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>
            <!--OTHER PREPARER JUST XS-->
            <span class="hidden-sm hidden-md hidden-lg hidden-xl"  v-if="myController.Incident.AddedBy=='0'" >
                <div class="col-xs-12">
                    <el-form-item class="hydroware-other">
                        <el-input 
                            v-model="myController.Incident.ReportPreparedByOther" 
                            :maxlength="150" 
                            placeholder="Enter other report prepared by types">
                        </el-input>
                    </el-form-item>
                </div>
            </span>
            <!--PREPARED DATE-->
            <!--For consistency and for ease of responsiveness I got rid of the checkbox for todays date-->
            <div class="col-xs-12 col-sm-4 col-md-3 col-lg-3">
                <el-form-item label="Report Date:"  prop="AddedOn">
                    <el-date-picker 
                        @blur=hydroware_picker_hasBlurred
                        type="date" 
                        format="MM-dd-yyyy" 
                        placeholder="Pick a date" 
                        style="width: 100%;"
                        v-model="myController.Incident.AddedOn">
                    </el-date-picker>
                </el-form-item>
            </div>
            <!--PREPARED TIME-->
            <!--For consistency and for ease of responsiveness I got rid of the checkbox for todays date-->
            <div class="col-xs-12 col-sm-4 col-md-3 col-lg-3">
                <el-form-item label="Report Time:"  prop="AddedOn" >
                    <el-time-picker 
                        :value-format="myController.$hydrowareCommonJS.hydrowareTimePickerFormat"
                        :format="myController.$hydrowareCommonJS.hydrowareTimePickerFormat"
                        :placeholder="myController.$hydrowareCommonJS.hydrowareTimePickerPlaceholder"
                        style="width: 100%;"
                        v-model="myController.Incident.AddOnTime">
                    </el-time-picker>
                </el-form-item>
            </div>
            <!--OTHER PREPARER bigger than XS-->
            <span class="hidden-xs"  v-if="myController.Incident.AddedBy=='0'" >
                <!--OTHER PREPARER-->
                <div class="col-xs-12 col-sm-4 col-md-6 col-lg-6 ">
                    <el-form-item class="hydroware-other">
                        <el-input
                            v-bind:class="{'hydroware-ishidden': myController.Incident.AddedBy!=='0'}" 
                            v-model="myController.Incident.ReportPreparedByOther" 
                            :maxlength="150" 
                            placeholder="Enter other report prepared by types">
                        </el-input>
                    </el-form-item>
                </div>
                <!--PLACEHOLDER FOR PREPARED DATE-->
                <div class="col-xs-12 col-sm-4 col-md-3 col-lg-3">
                    <hydroware-other-input-placeholder/>
                </div>
                <!--PLACEHOLDER FOR PREPARED TIME-->
                <div class="col-xs-12 col-sm-4 col-md-3 col-lg-3">
                    <hydroware-other-input-placeholder/>
                </div>
            </span>

        <!--VENUE----------------------------------------------------------------->
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <el-form-item label="Venue:" >
                    <el-select 
                        placeholder="Select Aquatic Venue" 
                        style="width: 100%;" 
                        v-model="myController.PoolIdEdit">
                        <el-option v-for="item in myController.pools" 
                            :key="item.PoolId" 
                            :label="item.PoolName"
                            :value="item.PoolId">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>

            <!--LOCATION-->
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <el-form-item label="Location:" prop="Location">
                    <el-input 
                        v-model="myController.Incident.LocationText" 
                        :maxlength="60" 
                        placeholder="Where did incident occur">
                    </el-input>
                </el-form-item>
            </div>

        <!--INCIDENT DATE-----------------------------------------------------------> 
            <div class="col-xs-12 col-sm-3">
                <el-form-item label="Incident Date:" prop="IncidentDate">
                    <el-date-picker
                        @blur=hydroware_picker_hasBlurred 
                        type="date" 
                        format="MM-dd-yyyy" 
                        placeholder="Pick a date" 
                        style="width: 100%;"
                        v-model="myController.Incident.IncidentDate">
                    </el-date-picker>
                </el-form-item>
            </div>
            <div class="col-xs-12 col-sm-3">
                <el-form-item label="Incident Time:" prop="IncidentTime" >
                    <el-time-picker 
                        :value-format="myController.$hydrowareCommonJS.hydrowareTimePickerFormat"
                        :format="myController.$hydrowareCommonJS.hydrowareTimePickerFormat"
                        :placeholder="myController.$hydrowareCommonJS.hydrowareTimePickerPlaceholder"
                        style="width: 100%;"
                        v-model="myController.Incident.IncidentTime">
                    </el-time-picker>
                </el-form-item>
            </div>        
            <!--INCIDENT TYPE-->
            <div class="col-xs-12 col-sm-3">
                <el-form-item label="Incident Type:" prop="PoolType"> <!--FG - FOOF - NOT MY PROP NAME -->
                    <el-select 
                        placeholder="Select Incident Type" 
                        style="width: 100%;" 
                        v-model="myController.Incident.PoolType">
                        <el-option 
                            v-for="item in myController.IncidentTypes" 
                            :key="item" 
                            :label="item" 
                            :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>
            <!--OTHER TYPE for XS display-->
            <span class="hidden-sm hidden-md hidden-lg hidden-xl"  v-if="myController.Incident.PoolType=='Other'">
                <div class="col-xs-12 col-sm-3">
                    <el-form-item class="hydroware-other">
                        <el-input 
                            v-model="myController.Incident.OtherTypeIncident" 
                            :maxlength="150" 
                            placeholder="Enter other incident types">
                        </el-input>
                    </el-form-item>
                </div>
            </span>
            <!--SEVERITY-->
            <div class="col-xs-12 col-sm-3">
                <el-form-item label="Inc. Severity:" prop="Severity">
                    <el-select 
                        placeholder="Select Incident Severity" 
                        style="width: 100%;" 
                        v-model="myController.Incident.Severity">
                        <el-option 
                            v-for="item in myController.Severitys" 
                            :key="item" 
                            :label="item" 
                            :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>
            <!--OTHER TYPE for displays bigger than XS-->
            <span class="hidden-xs"  v-if="myController.Incident.PoolType=='Other'">
                <div class="col-xs-12 col-sm-3"><hydroware-other-input-placeholder/></div>
                <div class="col-xs-12 col-sm-3"><hydroware-other-input-placeholder/></div>
                <div class="col-xs-12 col-sm-3">
                    <el-form-item class="hydroware-other">
                        <el-input 
                            v-bind:class="{'hydroware-ishidden': myController.Incident.PoolType!=='Other'}"
                            v-model="myController.Incident.OtherTypeIncident" 
                            :maxlength="150" 
                            placeholder="Enter other incident types">
                        </el-input>
                    </el-form-item>
                </div>
                <div class="col-xs-12 col-sm-3"><hydroware-other-input-placeholder/></div>
            </span>
            <!--NATURE-------------------------------------------------------------------->
            <div class="col-xs-12 col-sm-6">
                <el-form-item label="Nature Of Incident:" prop="NatureOfIncident">
                    <el-input class="hydroware-no-resize-textarea"
                        type="textarea" 
                        placeholder="Enter Nature of the Incident" 
                        v-model="myController.Incident.NatureOfIncident" 
                        :rows=2 
                        :maxlength="250">
                    </el-input>
                </el-form-item>
            </div>
            <!--DESCRIPTION-->
            <div class="col-xs-12 col-sm-6">
                <el-form-item label="Description  :" prop="Description">
                    <el-input 
                        class="hydroware-no-resize-textarea"
                        type="textarea" 
                        placeholder="Describe the incident" 
                        v-model="myController.Incident.Description" 
                        :rows=2 
                        :maxlength="400">
                    </el-input>
                </el-form-item>
            </div>
        <!--VIOLATOR------------------------------------------------------------------>
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <el-form-item label="Violator:" prop="ViolatorClass">
                    <el-select 
                        placeholder="Select type" 
                        style="width: 100%;" 
                        v-model="myController.Incident.ViolatorClass">
                        <el-option 
                            v-for="item in myController.Violator" 
                            :key="item" 
                            :label="item" 
                            :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>
            <!--VIOLATOR - ONLY XS-->
            <span v-if="myController.Incident.ViolatorClass=='Other'"
                class="hidden-sm hidden-md hidden-lg hidden-xl">
                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <el-form-item class="hydroware-other">
                        <el-input 
                            v-model="myController.Incident.ViolatorOther" 
                            :maxlength="150" 
                            placeholder="Enter other violator types">
                        </el-input>
                    </el-form-item>
                </div>
            </span>
            <!--BEHAVIOR-->
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <el-form-item label="Behavior:" prop="BehaviorType">
                    <el-select 
                        placeholder="Select Behavior Type" 
                        style="width: 100%;" 
                        v-model="myController.Incident.BehaviorType">
                        <el-option 
                            v-for="item in myController.IncidentBehavior" 
                            :key="item" 
                            :label="item" 
                            :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>
            <!--BEHAVIOR OTHER - ONLY XS-->
            <span v-if="myController.Incident.BehaviorType=='Other'"
                class="hidden-sm hidden-md hidden-lg hidden-xl">
                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <el-form-item class="hydroware-other">
                        <el-input 
                            v-model="myController.Incident.OtherTypeBehavior" 
                            :maxlength="150" 
                            placeholder="Enter behaviour">
                        </el-input>
                    </el-form-item>
                </div>
            </span>
            <!-- FG - FOOF -------------------------------------------------
            -- VIOLATOR OTHER AND BEHAVIOR OTHER FOR SCREENS OTHER THAN XS
            -- NOTE: OTHER VIOLATOR AND OTHER BEHAVIOR DISPLAY ON THE SAME LINE
            --
            -- If we need to display an "other" field for either
            -- violator or behavior then the following span is 
            -- displayed.  Within that span we use the v-bind:class 
            -- to determine whether each of those "other" fields
            -- is displayed.
            ----------------------------------------------------------> 
            <span class="hidden-xs"
                v-if="myController.Incident.ViolatorClass=='Other' 
                   || myController.Incident.BehaviorType =='Other'">
                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <el-form-item class="hydroware-other">
                        <el-input 
                            v-bind:class="{
                                'hydroware-ishidden': myController.Incident.ViolatorClass !== 'Other' 
                            }" 
                            v-model="myController.Incident.ViolatorOther" 
                            :maxlength="150" 
                            placeholder="Enter other violator types">
                        </el-input>
                    </el-form-item>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <el-form-item class="hydroware-other">
                        <el-input 
                            v-bind:class="{
                                'hydroware-ishidden': myController.Incident.BehaviorType !== 'Other'
                            }" 
                            v-model="myController.Incident.OtherTypeBehavior" 
                            :maxlength="150" 
                            placeholder="Enter behaviour">
                        </el-input>
                    </el-form-item>
                </div>
            </span>
        <!--MANAGER ON DUTY-->
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <el-form-item label="Manager On Duty" prop="ManagerId">
                    <el-select 
                        placeholder="Select Staff Member" 
                        style="width: 100%;" 
                        v-model="myController.Incident.ManagerOnDuty">
                        <el-option 
                            v-for="item in myController.staffmembers" 
                            :key="item.Id" 
                            :label="item.Name"
                            :value="item.Id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>
            <!--MANAGER ON DUTY OTHER - ONLY XS-->
            <span v-if="myController.Incident.ManagerOnDuty=='0'"
                class="hidden-sm hidden-md hidden-lg hidden-xl">
                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <el-form-item class="hydroware-other">
                            <el-input 
                                v-model="myController.Incident.ManagerOnDutyOther" 
                                :maxlength="150" 
                                placeholder="Enter manager on duty">
                            </el-input>
                        </el-form-item>
                </div>
            </span>
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <el-form-item label="Location Of Manager on Duty" prop="Area">
                    <el-input 
                        placeholder="Enter Location" 
                        v-model="myController.Incident.Area" 
                        :maxlength="30">
                    </el-input>
                </el-form-item>
            </div>
            <!--MANAGER ON DUTY FOR DISPLAYS OTHER THAN XS-->
            <span class="hidden-xs"  v-if="myController.Incident.ManagerOnDuty=='0'">
                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <el-form-item class="hydroware-other">
                        <el-input 
                            v-bind:class="{'hydroware-ishidden': myController.Incident.ManagerOnDuty!=='0'}"
                            v-model="myController.Incident.ManagerOnDutyOther" 
                            :maxlength="150" 
                            placeholder="Enter manager on duty">
                         </el-input>
                    </el-form-item>
                </div>
                <div class="col-xs-12 col-sm-3"><hydroware-other-input-placeholder/></div>
            </span>
        <!--RESPONSE----------------------------------------------------------------------->
            <div class="col-xs-12">
                <el-form-item label="Response:" prop="Response">
                    <el-input 
                        class="hydroware-no-resize-textarea"
                        type="textarea" 
                        placeholder="How did staff respond" 
                        v-model="myController.Incident.Response" 
                        :rows=2 
                        :maxlength="400">
                    </el-input>
                </el-form-item>
            </div>

        <!--POLICE------------------------------------------------------------------>
            <div class="col-xs-12 col-sm-4">
                <el-form-item label="Police:" prop="Police">
                    <el-checkbox 
                        v-model="myController.Incident.Police">
                    </el-checkbox>
                </el-form-item>
                <!--POLICE EXTRA INFO FOR XS-->
                <el-form-item
                     class="hydroware-other-checkbox hidden-sm hidden-md hidden-lg hidden-xl"  
                    prop="PoliceCase" 
                    v-if="myController.Incident.Police">
                    <el-input 
                        v-model="myController.Incident.PoliceCase" 
                        :maxlength="30" 
                        placeholder=" Enter Police Dept. Case">
                    </el-input>
                </el-form-item>
            </div>
            <!--FIRE DEPARTMENT-->
            <div class="col-xs-12 col-sm-4">
                <el-form-item label="Fire Department:" prop="FireDepartment">
                    <el-checkbox 
                        v-model="myController.Incident.FireDepartment">
                    </el-checkbox>
                </el-form-item>
                <!--FIRE DEPT EXTRA INFO FOR XS-->
                <el-form-item 
                     class="hydroware-other-checkbox hidden-sm hidden-md hidden-lg hidden-xl" 
                    prop="FireDepartmentCase" 
                    v-if="myController.Incident.FireDepartment">
                    <el-input 
                        v-model="myController.Incident.FireDepartmentCase" 
                        :maxlength="30" 
                        placeholder="Enter Fire Dept. Case">
                    </el-input>
                </el-form-item>
            </div>
            <!--EMS-->
            <div class="col-xs-12 col-sm-4">
                <el-form-item label="EMS:" prop="lastname">
                    <el-checkbox 
                        v-model="myController.Incident.EMS">
                    </el-checkbox>
                </el-form-item>
                <!--EMS Extra Info FOR XS-->
                <el-form-item
                    class="hydroware-other-checkbox hidden-sm hidden-md hidden-lg hidden-xl" 
                    prop="EMSCase" 
                    v-if="myController.Incident.EMS">
                    <el-input 
                        v-model="myController.Incident.EMSCase" 
                        :maxlength="30" 
                        placeholder="Enter EMS Case">
                    </el-input>
                </el-form-item>
            </div>
            <!--POLICE, FIRE DEPT, EMS FOR OTHER THAN XS-->
            <span
                v-if="myController.Incident.Police || myController.Incident.FireDepartment || myController.Incident.EMS">
                <!--POLICE-->
                <el-form-item
                    class="hydroware-other-checkbox hidden-xs col-sm-4"  
                    prop="PoliceCase">
                    <el-input 
                        v-bind:class="{'hydroware-ishidden': !myController.Incident.Police}"
                        v-model="myController.Incident.PoliceCase" 
                        :maxlength="30" 
                        placeholder=" Enter Police Dept. Case">
                    </el-input>
                </el-form-item>
                <!--FIRE DEPT-->
                <el-form-item 
                    class="hydroware-other-checkbox hidden-xs col-sm-4"  
                    prop="FireDepartmentCase">
                    <el-input 
                        v-bind:class="{'hydroware-ishidden': !myController.Incident.FireDepartment}"
                        v-model="myController.Incident.FireDepartmentCase" 
                        :maxlength="30" 
                        placeholder="Enter Fire Dept. Case">
                    </el-input>
                </el-form-item>
                <!--EMS-->
                <el-form-item 
                    class="hydroware-other-checkbox hidden-xs col-sm-4" 
                    prop="EMSCase">
                    <el-input
                        v-bind:class="{'hydroware-ishidden': !myController.Incident.EMS}"
                        v-model="myController.Incident.EMSCase" 
                        :maxlength="30" 
                        placeholder="Enter EMS Case">
                    </el-input>
                </el-form-item>
            </span>

        <!--INVOLVED PARTIES TABLE-->
        <div class="row">
            <h5 style="float:left;padding-left:10px;font-weight:700">
                <span class="heading">
                    Involved party(s)
                </span>
            </h5>
            <div class="btn-group" 
                style="float:right; margin-right:14px; ">
                <button 
                    v-bind:class="[{hydroware_hidden: $hydrowareSecurityJS.disableDataEntry_A('incidents',isAddingOrEditing)}]" 
                    class="btn btn-white btn-sm" 
                    onclick="return false;" 
                    @click="myController.addInvolvedParty">
                    Add Involved Party
                </button>
            </div>
        </div>
        <div>
            <table style="max-width:100%; overflow-x:auto;"
                    class="hydroware-table table table-striped table-bordered table-hover gride TFtable">
                <thead class="hidden-md hidden-xs hidden-sm"><!--header does not display on smaller devices-->
                    <tr>
                        <th class="hidden-md hidden-xs hidden-sm">
                            Name
                        </th>
                        <th class="hidden-md hidden-xs hidden-sm">
                            Address
                        </th>
                        <th class="hidden-md hidden-xs hidden-sm">
                            City
                        </th>
                        <th class="hidden-md hidden-xs hidden-sm hydroware-state-column">
                            State
                        </th>
                        <th class="hidden-md hidden-xs hidden-sm hydroware-zipcode-column">
                            Zip Code
                        </th>
                        <th class="hidden-md hidden-xs hidden-sm hydroware-phonenumber-column">
                            Phone Number
                        </th>
                        <th class="hidden-md hidden-xs hidden-sm hydroware-age-column">
                             Age
                        </th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <!--WHEN THERE IS NOT DATA TO DISPLAY SIMPLY PUT UP A SINGLE ROW STATING THAT -->
                    <tr
                        v-if="myController.Incident.IncidentInvolvedPartyList.length < 1 || myController.Incident.IncidentInvolvedPartyList == null"
                        class="" style="">
                        <td colspan="8" style="text-align:center;">
                            <h3>
                                <span
                                    style="font-weight: 700;opacity: 0.6;color:gray">
                                    {{myController.$hydrowareCommonJS.hydrowareMsgForNoData}}
                                </span>
                            </h3>
                        </td>
                    </tr>
                    <!--END NOTHING TO DISPLAY-->
                    <tr  v-for="(item,index) in myController.Incident.IncidentInvolvedPartyList"
                        v-bind:key="item.Id">
                        <!--FG - FOOF - After Cert - First Release (7) - reworked this table to display nicely on smaller devices-->
                        <!--ON SMALLER DEVICES TWO DATA COLUMNS ARE DISPLAYED-->
                        <!--SMALLER DEVICES - COLUMN 1 -->
                        <td class="hidden-lg hidden-xl hydroware-label-in-column hydroware-label-in-column_100"><!--SMALLER DEVICES-->
                            <span class=hydroware-label-fixed>Name:</span>
                            <el-input 
                                class=hydroware-input-for-fixed-label
                                type=text
                                v-model="item.Name" 
                                :maxlength=30 
                                placeholder="Enter Name">
                            </el-input>
                            <div>
                            <span class=hydroware-label-fixed>Phone #:</span>
                            <el-input class=hydroware-input-for-fixed-label
                                type=text
                                v-model="item.PhoneNumber" 
                                v-hydromask="'(###) ###-####'" 
                                placeholder="Enter Phone Number">
                            </el-input>
                            </div>
                            <div>
                            <span class=hydroware-label-fixed>Age:</span>
                            <el-input class=hydroware-input-for-fixed-label
                                type=text
                                v-model="item.Age"
                                :maxlength=3 
                                v-hydromask="'###'" 
                                placeholder="Enter Age">
                            </el-input>
                            </div>
                        </td>
                        <!--END SMALLER DEVICES COLUMN 1-->
                        <!--COLUMN BELOW DISPLAYS ON SMALLER DEVICES - ADDRESS, STATE, ETC -->
                        <td class="hidden-lg hidden-xl hydroware-label-in-column hydroware-label-in-column_100"><!--SMALLER DEVICES-->
                            <span class=hydroware-label-fixed>Address:</span>
                            <el-input 
                                class=hydroware-input-for-fixed-label
                                type=text
                                v-model="item.Address" 
                                :maxlength=30 
                                placeholder="Enter Address">
                            </el-input>
                            
                            <div>
                            <span class=hydroware-label-fixed>City:</span>
                            <el-input 
                                class=hydroware-input-for-fixed-label
                                type=text
                                v-model="item.City" 
                                :maxlength=30 
                                placeholder="Enter City">
                            </el-input>
                            </div>
                            <div>
                            <span class=hydroware-label-fixed>State:</span>
                            <el-input 
                                class=hydroware-input-for-fixed-label
                                type=text
                                v-model="item.State" 
                                :maxlength=2 
                                placeholder="Enter State">
                            </el-input>
                            </div>
                            <div>
                            <span class=hydroware-label-fixed>Zip Code:</span>
                            <el-input 
                                class=hydroware-input-for-fixed-label
                                type=text
                                v-model="item.ZipCode" 
                                :maxlength=10
                                placeholder="Enter Zip Code" 
                                v-hydromask="'#####-####'">
                            </el-input>
                            </div>            
                        </td>
                        <!--END SMALLER DEVICES COLUMN 2-->
                        <!--END SMALLER DEVICES COLUMNS-->
                        
                        <!--LARGER DEVICES DISPLAY A COLUMN FOR EACH DATUM-->
                        <!--NAME LARGER DEVICES-->
                        <td class="hidden-md hidden-xs hidden-sm">
                            <el-input 
                                v-model="item.Name" 
                                :maxlength=30 
                                placeholder="Enter Name">
                            </el-input>
                        </td>
                        <!--ADDRESS LARGER DEVICES-->
                        <td class="hidden-md hidden-xs hidden-sm">
                            <el-input 
                                v-model="item.Address" 
                                :maxlength=30 
                                placeholder="Enter Address">
                            </el-input>
                        </td>
                        <!--CITY LARGER DEVICES-->
                        <td class="hidden-md hidden-xs hidden-sm">
                            <el-input 
                                v-model="item.City" 
                                :maxlength=30 
                                placeholder="Enter City">
                            </el-input>
                        </td>
                        <td class="hidden-md hidden-xs hidden-sm">
                            <el-input 
                                v-model="item.State" 
                                :maxlength=30 
                                placeholder="Enter State">
                            </el-input>
                        </td>
                        <td class="hidden-md hidden-xs hidden-sm">
                            <!--FG - FOOF - After Cert - First Release Security (7) changed field below to be el-input-->
                            <el-input 
                                type="text" 
                                v-model="item.ZipCode" 
                                placeholder="Enter Zip Code" 
                                v-mask="'############'" >
                            </el-input>
                        </td>
                        <td class="hidden-md hidden-xs hidden-sm">
                            <!--FG - FOOF - After Cert - First Release Security (7) changed field below to be el-input-->
                            <el-input type="text" 
                                v-model="item.PhoneNumber" 
                                placeholder="Enter Phone Number" 
                                v-hydromask="'(###) ###-####'" >
                            </el-input>                            
                        </td>
                        <td class="hidden-md hidden-xs hidden-sm">
                            <!--FG - FOOF - After Cert - First Release Security (7) changed field below to be el-input-->
                            <el-input type="text" 
                                v-model="item.Age" 
                                v-mask="'###'" 
                                placeholder="Enter Age">
                            </el-input>
                        </td>
                        <!--END LARGER DEVICE COLUMNS-->

                        <!--THE BUTTON(S) COLUMN DISPLAYS ON ALL DEVICES-->
                        <td class="hydroware-1-button-column">
                            <button 
                                v-if="$hydrowareSecurityJS.canDelete_A('incidents')"
                                type="button" 
                                class="el-button el-button--danger el-button--small" 
                                title="" 
                                style="background-color: #ff4949!important;" 
                                @click="myController.removeInvolved(index)">
                                    <i class="el-icon-delete"
                                        style="color:white !important;">
                                    </i>
                            </button>
                        </td>

                    </tr>

                </tbody>
            </table>
        </div>

        <!--WITNESSES-->
        <!--<div class="col-lg-12 col-md-12">-->
            <div class="row">
                <h5 style="float:left;padding-left:10px;font-weight:700">
                    <span class="heading">Witness</span>
                </h5>
                <div class="btn-group" style="float:right; margin-right:14px; ">
                    <button class="btn btn-white btn-sm" 
                        v-bind:class="[{hydroware_hidden: $hydrowareSecurityJS.disableDataEntry_A('incidents',isAddingOrEditing)}]" 
                        onclick="return false;" 
                        @click="myController.addWitness()">
                        Add Witness
                    </button>
                </div>
            </div>

            <!-- FG - FOOF - May 7 2019 ---- fix up the table below
            <table style="max-width:100%; 
                overflow-x:auto;"
                class="table table-striped table-bordered table-hover gride TFtable">
            -->
            <div>
            <table style="max-width:100%; overflow-x:auto;"
                class="hydroware-table table table-striped table-bordered table-hover gride TFtable">
                <thead class="hidden-md hidden-xs hidden-sm">
                    <tr>
                        <th class="hidden-md hidden-xs hidden-sm">
                            Name
                        </th>
                        <th class="hidden-md hidden-xs hidden-sm">
                            Address
                        </th>
                        <th class="hidden-md hidden-xs hidden-sm">
                            City
                        </th>
                        <th  class="hidden-md hidden-xs hidden-sm hydroware-state-column">
                            State
                        </th>
                        <th class="hidden-md hidden-xs hidden-sm hydroware-zipcode-column">
                            Zip Code
                        </th>
                        <th class="hidden-md hidden-xs hidden-sm hydroware-phonenumber-column">
                            Phone Number
                        </th>
                        <th class="hidden-md hidden-xs hidden-sm hydroware-age-column">
                            Age
                        </th>
                        <th></th>
                    </tr>
                </thead>
            <tbody>
                <tr v-if="myController.Incident.IncidentWitnessList.length < 1 || myController.Incident.IncidentWitnessList == null"
                    class="" style="">
                        <td colspan="8" style="text-align:center;">
                            <h3>
                                <span style="font-weight: 700;opacity: 0.6;color:gray">
                                    {{myController.$hydrowareCommonJS.hydrowareMsgForNoData}}
                                </span>
                            </h3>
                        </td>
                </tr>
                <tr 
                    v-for="(item,index) in myController.Incident.IncidentWitnessList"
                        v-bind:key="item.Id">

<!--FG - FOOF - After Cert - First Release (7) - reworked this table to display nicely on smaller devices-->
                        <!--ON SMALLER DEVICES TWO DATA COLUMNS ARE DISPLAYED-->
                        <!--SMALLER DEVICES - COLUMN 1 -->
                        <td class="hidden-lg hidden-xl hydroware-label-in-column hydroware-label-in-column_100"><!--SMALLER DEVICES-->
                            <span class=hydroware-label-fixed>Name:</span>
                            <el-input 
                                class=hydroware-input-for-fixed-label
                                type=text
                                v-model="item.Name" 
                                :maxlength=30 
                                placeholder="Enter Name">
                            </el-input>
                            <div>
                            <span class=hydroware-label-fixed>Phone #:</span>
                            <el-input class=hydroware-input-for-fixed-label
                                type=text
                                v-model="item.PhoneNumber" 
                                v-hydromask="'(###) ###-####'" 
                                placeholder="Enter Phone Number">
                            </el-input>
                            </div>
                            <div>
                            <span class=hydroware-label-fixed>Age:</span>
                            <el-input class=hydroware-input-for-fixed-label
                                type=text
                                v-model="item.Age"
                                :maxlength=3 
                                v-hydromask="'###'" 
                                placeholder="Enter Age">
                            </el-input>
                            </div>
                        </td>
                        <!--END SMALLER DEVICES COLUMN 1-->
                        <!--COLUMN BELOW DISPLAYS ON SMALLER DEVICES - ADDRESS, STATE, ETC -->
                        <td class="hidden-lg hidden-xl hydroware-label-in-column hydroware-label-in-column_100"><!--SMALLER DEVICES-->
                            <span class=hydroware-label-fixed>Address:</span>
                            <el-input 
                                class=hydroware-input-for-fixed-label
                                type=text
                                v-model="item.Address" 
                                :maxlength=30 
                                placeholder="Enter Address">
                            </el-input>
                            
                            <div>
                            <span class=hydroware-label-fixed>City:</span>
                            <el-input 
                                class=hydroware-input-for-fixed-label
                                type=text
                                v-model="item.City" 
                                :maxlength=30 
                                placeholder="Enter City">
                            </el-input>
                            </div>
                            <div>
                            <span class=hydroware-label-fixed>State:</span>
                            <el-input 
                                class=hydroware-input-for-fixed-label
                                type=text
                                v-model="item.State" 
                                :maxlength=2 
                                placeholder="Enter State">
                            </el-input>
                            </div>
                            <div>
                            <span class=hydroware-label-fixed>Zip Code:</span>
                            <el-input 
                                class=hydroware-input-for-fixed-label
                                type=text
                                v-model="item.ZipCode" 
                                :maxlength=10
                                placeholder="Enter Zip Code" 
                                v-hydromask="'#####-####'">
                            </el-input>
                            </div>            
                        </td>
                        <!--END SMALLER DEVICES COLUMN 2-->
                        <!--END SMALLER DEVICES COLUMNS-->
                        
                        <!--COLS BELOW DISPLAY ON LARGER DEVICES-->
                        <td class="hidden-md hidden-xs hidden-sm">
                            <el-input 
                                v-model="item.Name" 
                                :maxlength=30 
                                placeholder="Enter Name">
                            </el-input>
                        </td>
                        <td class="hidden-md hidden-xs hidden-sm">
                            <el-input 
                                v-model="item.Address" 
                                :maxlength=30 
                                placeholder="Enter Address">
                            </el-input>
                        </td>
                        <td class="hidden-md hidden-xs hidden-sm">
                            <el-input 
                                v-model="item.City" 
                                :maxlength=30 
                                placeholder="Enter City">
                            </el-input>
                        </td>
                        <td class="hidden-md hidden-xs hidden-sm">
                            <el-input 
                                v-model="item.State" 
                                :maxlength=30 
                                placeholder="Enter State">
                            </el-input>
                        </td>
                        <td class="hidden-md hidden-xs hidden-sm">
                            <!--FG - FOOF - After Cert - First Release Security (7) changed field below to be el-input-->
                            <!--
                            <input class="eltextcopy placeholder-class" 
                                type="number" placeholder="Enter Zip Code" 
                                v-model="item.ZipCode" 
                                maxlength="12" >
                            -->
                            <el-input
                                type="number" 
                                placeholder="Enter Zip Code" 
                                v-model="item.ZipCode" 
                                maxlength="12" >
                            </el-input>
                       </td>
                       <td class="hidden-md hidden-xs hidden-sm">
                           <!--FG - FOOF - After Cert - First Release Security (7) changed field below to be el-input-->
                            <!--
                            <input type="text" 
                                class="eltextcopy placeholder-class" 
                                placeholder="Enter Phone Number" 
                                v-model="item.PhoneNumber" 
                                v-mask="'(###) ###-####'" >
                            -->
                            <el-input type="text" 
                                placeholder="EnterEEEEE Phone Number" 
                                v-model="item.PhoneNumber" 
                                v-hydromask="'(###) ###-####'" >
                            </el-input>
                        </td>
                        <td class="hidden-md hidden-xs hidden-sm">
                            <!--FG - FOOF - After Cert - First Release Security (7) changed field below to be el-input-->
                            <!--
                            <input type="number" 
                                class="eltextcopy placeholder-class" 
                                placeholder="Enter Age" 
                                v-model="item.Age" 
                                maxlength="3">
                            -->
                            <el-input 
                                type="number" 
                                placeholder="Enter Age" 
                                v-model="item.Age" 
                                maxlength="3">
                            </el-input>
                        </td>
                        <td class="hydroware-1-button-column">
                            <!--FG - FOOF- After Cert - First Release (7) - First Release Security - Test to see if delete btn should display -->
                            <button type="button" 
                                v-if="$hydrowareSecurityJS.canDelete_A('incidents')"
                                class="el-button el-button--danger el-button--small" 
                                title="" 
                                style="background-color: #ff4949!important;" 
                                @click="myController.removeWitness(index)">
                                    <i class="el-icon-delete"
                                        style="color:white !important;">
                                    </i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-xs-12">
            <div class="row">
                <h5 style="float:left;padding-left:10px;font-weight:700">
                    <span class="heading">
                        Staff on Duty
                    </span>
                </h5>
                <div class="btn-group"
                    style="float:right; margin-right:14px; ">
                    <button class="btn btn-white btn-sm"
                        v-bind:class="[{hydroware_hidden: $hydrowareSecurityJS.disableDataEntry_A('incidents',isAddingOrEditing)}]"  
                        onclick="return false;" 
                        @click="myController.addStaff()">
                        Add Employee
                    </button>
                </div>
            </div>
            <table style="max-width:100%; overflow-x:auto;"
                class="hydroware-table table table-striped table-bordered table-hover gride TFtable">
                <thead>
                    <tr>
                        <th>
                            Name
                        </th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-if="myController.Incident.IncidentStaffOnDutyList.length < 1 || myController.Incident.IncidentStaffOnDutyList == null"
                        class="" style="">
                        <td colspan="2" 
                            style="text-align:center;">
                            <h3>
                                <span style="font-weight: 700;opacity: 0.6;color:gray">
                                    {{myController.$hydrowareCommonJS.hydrowareMsgForNoData}}
                                </span>
                            </h3>
                        </td>
                    </tr>
                    <tr v-for="(item,index) in myController.Incident.IncidentStaffOnDutyList"
                        v-bind:key="item.Id">
                        <td>
                            <el-select 
                                placeholder="Select Employee" 
                                style="width: 100%;" 
                                v-model="item.StaffId">
                                <el-option 
                                    v-for="item1 in myController.staffmembers" 
                                    :key="item1.Id" 
                                    :label="item1.Name"
                                    :value="item1.Id">
                                </el-option>
                            </el-select>
                        
                            <el-form-item v-if="item.StaffId=='0'">
                                <el-input 
                                    v-model="item.StaffOther" 
                                    :maxlength="150" 
                                    placeholder="Enter other Enter other staff on duty">
                                </el-input>
                            </el-form-item>
                        </td>
                        <td class="hydroware-1-button-column">
                            <button type="button" 
                                v-if="$hydrowareSecurityJS.canDelete_A('incidents')"
                                class="el-button el-button--danger el-button--small" 
                                title="" 
                                style="background-color: #ff4949!important;" 
                                @click="myController.removeStaff(index)">
                                <i class="el-icon-delete"
                                    style="color:white !important;">
                                </i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <!--END INCIDENT FORM-->
</template>

<script>
export default {
    props: ['myController','isAddingOrEditing']
  }
</script>    

<!--OLD CODE-->
            <!--CODE BELOW HAS THE "TODAY'S DATE" CHECKBOX----------------------------------------------
            <div class="col-lg-4 col-md-4">
                <el-form-item label="Report Date:" prop="IsCurrentReportDate">
                    <el-checkbox v-model="myController.IsCurrentReportDate" >Today's Date</el-checkbox>
                </el-form-item>
                <el-form-item prop="AddedOn" v-if="!myController.IsCurrentReportDate">
                    <el-date-picker
                        @blur=hydroware_picker_hasBlurred 
                        type="date" 
                        format="MM-dd-yyyy" 
                        placeholder="Pick a Date" 
                        style="width: 100%;"
                        v-model="myController.Incident.AddedOn">
                    </el-date-picker>
                </el-form-item>
            </div>
            ---------------------------------------------------------------------------------------------->
            <!--CODE BELOW CONTAINS THE "Current Time" CHECKBOX -------------------------------------------
            <div class="col-lg-4 col-md-4">
                <el-form-item label="Report Time:" prop="IsCurrentReportTime">
                    <el-checkbox v-model="myController.IsCurrentReportTime">Current Time</el-checkbox>
                </el-form-item>
                <el-form-item prop="AddedOn" v-if="!myController.IsCurrentReportTime">
                    <el-time-picker 
                        format="HH:mm" 
                        placeholder="Pick a Time" 
                        v-model="myController.Incident.AddOnTime">
                    </el-time-picker>
                </el-form-item>
            </div>
            ---------------------------------------------------------------------------------------------->


// WEBPACK FOOTER //
// incidentForm.vue?526011c6